import React from "react"

import { useTranslation } from "react-i18next"
import DayJS from "react-dayjs"

import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableContainer from "@mui/material/TableContainer"
import TableRow from "@mui/material/TableRow"
import Container from "@mui/material/Container"
import Grid from "@mui/material/Grid"

const VoucherLogRow = ({ row }) => {
  const { t } = useTranslation("voucherStatus")

  return (
    <TableRow>
      <TableCell>
        <DayJS format="DD.MM.YYYY HH.mm" date={row.aika} />
      </TableCell>
      <TableCell>{t("" + row.tila)}</TableCell>
      <TableCell>{row.nimi}</TableCell>
    </TableRow>
  )
}

const VoucherLog = ({ log }) => {
  return (
      
    <TableContainer>
        <Table>
          <TableBody>
            {log.map((row) => (
              <VoucherLogRow row={row} />
            ))}
          </TableBody>
        </Table>
    </TableContainer>       
  )
}

export default VoucherLog
